import Typography from "@material-ui/core/Typography";
import React from "react";
import { useTranslate } from "react-admin";

import { deviationHelpByStatusAndType } from "../../entities/DeviationHelp";

const DeviationHelper = ({ status, deviationType }) => {
	const translate = useTranslate();

	const translationKey = deviationHelpByStatusAndType[status]?.[deviationType];
	const helpText = translationKey !== undefined ? translate(`osfc.enums.deviation_help.${translationKey}`) : "";

	return (
		<Typography
			variant="h5"
			color="textSecondary"
			style={{ width: "100%", textAlign: "center" }}
		>
			{helpText}
		</Typography>
	);
};

export default DeviationHelper;
